
export const isSearching = state => state.search.searching;

export const getTotalSongs = state => state.search.songs.total;

export const getSongs = state => state.search.songs.results;

export const getAlbums = state => state.search.albums.results;

export const getArtists = state => state.search.artists.results;
